const initialState = {
    data: [],
  };
  
  const stawkiJednorazoweReducer = (state = initialState, action) => {
    switch (action.type) {
      case 'SET_STAWKI_JEDNORAZOWE':
        return { ...state, data: action.payload };
      default:
        return state;
    }
  };
  
  export default stawkiJednorazoweReducer;